import React, { useContext, useEffect } from "react";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Topbar from '../components/Topbar';
import Platform from '../components/terms/platform_body';
import { LanguageContext } from "../context/LanguageContext";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Platform", "terms/platform_body_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.Platform || { Main: {} };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <Platform />
    </div>
  );
};

export default Page;